module.exports = __webpack_public_path__ + "img/19.b331b6f6.jpg";